import { render, staticRenderFns } from "./checkList.vue?vue&type=template&id=2b75c1a9"
import script from "./checkList.vue?vue&type=script&lang=js"
export * from "./checkList.vue?vue&type=script&lang=js"
import style0 from "./checkList.vue?vue&type=style&index=0&id=2b75c1a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports